// client/src/components/AdForm.js
import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AdForm = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [price, setPrice] = useState('');
  const [location, setLocation] = useState('');
  const [image, setImage] = useState(null);
  const navigate = useNavigate(); // For redirecting after creation

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append('price', price);
    formData.append('location', location);
    if (image) formData.append('image', image);

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/ads', formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      alert('Ad created successfully!');
      navigate('/'); // Redirect to home page
    } catch (error) {
      console.error("Full Error:", error);

      // Mongoose validation errors usually come back in error.response.data.error
      // Sometimes they come back as a string, sometimes as an object
      let errorMessage = 'Failed to create ad';
      if (error.response?.data?.error) {
        if (typeof error.response.data.error === 'string') {
          errorMessage = error.response.data.error;
        } else if (error.response.data.error?.message) {
          errorMessage = error.response.data.error.message;
        }
      }

      alert(errorMessage); // Now it will show "Ad validation failed: title is shorter than minimum..."
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="formTitle" className="mb-3">
        <Form.Label>Title</Form.Label>
        <Form.Control type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formContent" className="mb-3">
        <Form.Label>Content</Form.Label>
        <Form.Control as="textarea" value={content} onChange={(e) => setContent(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formPrice" className="mb-3">
        <Form.Label>Price</Form.Label>
        <Form.Control type="number" value={price} onChange={(e) => setPrice(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formLocation" className="mb-3">
        <Form.Label>Location</Form.Label>
        <Form.Control type="text" value={location} onChange={(e) => setLocation(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formImage" className="mb-3">
        <Form.Label>Image</Form.Label>
        <Form.Control type="file" onChange={(e) => setImage(e.target.files[0])} accept="image/*" />
      </Form.Group>
      <Button variant="primary" type="submit">Create Ad</Button>
    </Form>
  );
};

export default AdForm;